import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";

import styles from './styles.module.css';
import Title from 'src/pages/home/components/title/Title';
import { useTranslation } from 'react-i18next';
import data, { ServiceCardType } from "./data";
import { isRTL } from 'src/utils/global';


const Services = () => {
    const { i18n, t } = useTranslation(['home']);

    return (
        <section data-aos="fade-up" className={`${styles.services__section} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className={styles.title}>
                    <Title lgTitle={t("services.title.lg")} smTitle={t("services.title.sm")} />
                </div>
                <div className={styles.cards__con}>
                    <div className='row'>
                        {data.map((service: ServiceCardType, index) => {
                            return <div key={service.id} className='col-12 col-xl-4 col-md-6 mb-5 px-4 px-sm-3'>
                                <Link to={`/services#${service.id}`} className={`${styles.card}`}>
                                    <div className={styles.img__con}>
                                        <img src={service.img} alt={service.title[i18n.language]} />
                                    </div>
                                    <div className={styles.overlay}>
                                        <h3>
                                            {service.title[i18n.language]}
                                        </h3>
                                        <div className={styles.link}>{t('services.btn')}
                                            {" "}
                                            {isRTL() ? <FaArrowLeft /> : <FaArrowRight />}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        })}

                        <div className='col-12  mx-auto mt-md-4 mt-sm-3 mt-2'>
                            <Link to={'/services'} className={`${styles.more_btn} bttn_primary`}>
                                <span>
                                    {t('services.more_btn')}
                                </span>
                                <div className={styles.moreIcon}>
                                    {isRTL() ? <FaArrowLeft /> : <FaArrowRight />}

                                </div>
                            </Link>
                        </div>

                    </div>
                </div>

            </div>
        </section >

    )
}


export default Services;
